import { Calendar, Clipboard, CreditCard, File, Layers } from "react-feather";
import { FEATURE_FUNCTION_SELECTION } from "../../../Constant/FeatureSelection";

const quickOptionData = [
  {
    id: 1,
    title: "Tambah Transaksi",
    path: `${process.env.PUBLIC_URL}/transaksi/buattransaksi`,
    icon: <Layers />,
    feature: FEATURE_FUNCTION_SELECTION.Transaksi.Create,
  },
  {
    id: 2,
    title: "Ajukan Realokasi",
    path: `${process.env.PUBLIC_URL}/realokasi/buatrealokasi`,
    icon: <Calendar />,
    feature: FEATURE_FUNCTION_SELECTION.Realokasi.Create,
  },
  {
    id: 3,
    title: "Ajukan Akun Baru",
    path: `${process.env.PUBLIC_URL}/daftarakun`,
    icon: <Clipboard />,
    feature: FEATURE_FUNCTION_SELECTION.AkunBaru.Create,
  },
  {
    id: 4,
    title: "Tambah Uang Muka Operasional",
    path: `${process.env.PUBLIC_URL}/umo/formumo`,
    icon: <CreditCard />,
    feature: FEATURE_FUNCTION_SELECTION.UMO.Create,
  },
  {
    id: 5,
    title: "Tambah Uang Muka Kegiatan",
    path: `${process.env.PUBLIC_URL}/umk/formumk`,
    icon: <CreditCard />,
    feature: FEATURE_FUNCTION_SELECTION.UMK.Create,
  },
  {
    id: 6,
    title: "Pergi ke Tanda Terima",
    path: `${process.env.PUBLIC_URL}/transaksi/tandaterima`,
    icon: <File />,
    feature: FEATURE_FUNCTION_SELECTION.TandaTerima.Read,
  },
];

export default quickOptionData;